import React from "react";
import usePluginEntities from "hooks/usePluginEntities";
import SecurityPage from "components/security/teaser/SecurityPage";
const SecurityPageEntry = () => {
  const securityPagePlugins = usePluginEntities("securityPage");
  if (securityPagePlugins == null ? void 0 : securityPagePlugins.length) {
    return /* @__PURE__ */ React.createElement(React.Fragment, null, securityPagePlugins.map((Page, index) => (
      // eslint-disable-next-line react/no-array-index-key
      /* @__PURE__ */ React.createElement(Page, { key: index })
    )));
  }
  return /* @__PURE__ */ React.createElement(SecurityPage, null);
};
export default SecurityPageEntry;
